import { useState } from 'react';

export function useClipboard(timeout: number | null = 2000) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      if (typeof timeout === 'number' && timeout > 0) {
        setTimeout(() => setCopied(false), timeout);
      }
    } catch (error) {
      console.error('Failed to copy to clipboard', error);
    }
  };

  return { copied, copyToClipboard };
}
